import { render, staticRenderFns } from "./ListRecipes.vue?vue&type=template&id=069633d9"
import script from "./ListRecipes.vue?vue&type=script&lang=js"
export * from "./ListRecipes.vue?vue&type=script&lang=js"
import style0 from "./ListRecipes.vue?vue&type=style&index=0&id=069633d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports